export default "__VITE_ASSET__437e02d1__"